// ContactSection.tsx
import React, { useState } from 'react';
import { Mail, Phone, MapPin, CheckCircle, Loader, ArrowRight, Instagram, Facebook, Youtube, Sparkles } from 'lucide-react';
import './ContactSection.css';
import { IoLogoAppleAppstore, IoLogoGooglePlaystore } from "react-icons/io5";
import { FaWhatsapp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hoveredSocial, setHoveredSocial] = useState<number | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
const handleSubmit = () => {
  const yourEmail = 'flooron@gmail.com';
  const subject = encodeURIComponent(`Website Contact: ${formData.subject}`);
  const body = encodeURIComponent(
    `Hello,\n\n` +
    `You received a new message from your website contact form:\n\n` +
    `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
    `Name: ${formData.name}\n` +
    `Email: ${formData.email}\n` +
    `Subject: ${formData.subject}\n` +
    `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n` +
    `Message:\n${formData.message}\n\n` +
    `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
    `Sent from website contact form\n` +
    `Date: ${new Date().toLocaleString()}`
  );

  // Try Gmail compose first, fallback to mailto
  const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${yourEmail}&su=${subject}&body=${body}`;
  const mailtoURL = `mailto:${yourEmail}?subject=${subject}&body=${body}`;

  // Use a direct anchor click — avoids pop-up blockers
  const link = document.createElement('a');
  link.href = gmailURL;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setIsSubmitted(true);
  setTimeout(() => {
    setIsSubmitted(false);
    setFormData({ name: '', email: '', subject: '', message: '' });
  }, 3000);
};


  return (
    <div className="contact-section">
 
      <div className="background-doodles">
        <svg className="doodle-svg">
          <circle cx="10%" cy="20%" r="100" fill="none" stroke="#ff006e" strokeWidth="3" className="doodle-line" style={{ animationDelay: '0s' }} />
          <circle cx="85%" cy="15%" r="80" fill="none" stroke="#8338ec" strokeWidth="3" className="doodle-line" style={{ animationDelay: '0.5s' }} />
          <rect x="5%" y="70%" width="120" height="120" fill="none" stroke="#3a86ff" strokeWidth="3" className="doodle-line" style={{ animationDelay: '1s' }} />
          <path d="M 80% 75% Q 85% 80%, 90% 75%" fill="none" stroke="#06ffa5" strokeWidth="3" className="doodle-line" style={{ animationDelay: '1.5s' }} />
        </svg>
      </div>
      
      <div className="floating-shape shape-1"></div>
      <div className="floating-shape shape-2"></div>
      <div className="floating-shape shape-3"></div>
      <div className="floating-shape shape-4"></div>

      <div className="contact-container">

        <div className="contact-header">
          <div className="header-badge">
            <Sparkles className="badge-icon" />
            <span className="badge-text">Wholesale Crafting Products</span>
          </div>
          
          <h1 className="main-title">
            <span className="title-text">Kangan Store</span>
          </h1>
          
          <p className="main-subtitle">
            Crafting Excellence, Delivering Quality
          </p>
        </div>

        <div className="main-grid">
          <div className="left-column">
            <div className="contact-info-card">
              <h2 className="section-title">Get in Touch</h2>
              
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <div className="icon-wrapper icon-purple">
                    <MapPin className="contact-icon" strokeWidth={3} />
                  </div>
                  <div className="contact-info-content">
                    <h3 className="info-label">Visit Us</h3>
                    <p className="info-text">
                      12/1 P.Y. Road, Near Gurudwara<br />
                      Rajwada, Indore (MP)
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="icon-wrapper icon-pink">
                    <Phone className="contact-icon" strokeWidth={3} />
                  </div>
                  <div className="contact-info-content">
                    <h3 className="info-label">Call Us</h3>
                    <p className="info-highlight">0731-4978968</p>
                    <p className="info-text">99777-77035, 9827092017</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="icon-wrapper icon-cyan">
                    <Mail className="contact-icon" strokeWidth={3} />
                  </div>
                  <div className="contact-info-content">
                    <h3 className="info-label">Email Us</h3>
                    <p className="info-highlight info-email">flooron@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="quick-links-card">
              <h3 className="subsection-title">Quick Links</h3>
              <div className="quick-links-grid">
                {[
                  {
                    icon : IoLogoGooglePlaystore,
                    link : 'https://play.google.com/store/apps/details?id=com.flooronmobile',
                    label : 'Get The App On Playstore'
                  },
                  {
                    icon:IoLogoAppleAppstore,
                    link:'https://apps.apple.com/in/app/floor-on/id6761125545',
                    label:'Get The App On App Store'}].map((link, idx) => {
                  const Icon = link.icon;
                  const colorClass = ['link-pink', 'link-purple', 'link-cyan', 'link-yellow'][idx];
                  return (
                    <button key={idx} className={`quick-link-button ${colorClass}`} onClick = {()=>{window.open(link.link, '_blank')}}>
                      <Icon className="quick-link-icon" strokeWidth={3} />
                      <span className="quick-link-text">{link.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="information-card">
              <h3 className="subsection-title">Information </h3>
              <div className="info-links-grid">
                {[
                //  "International Shipping",
                 {label:"Privacy policy",link:'information/privacy-policy'}, 
                //  "Shipping policy",
                 {label:"Terms & Conditions",link:'information/terms-of-use'},
                //  "Refund & cancellation",
                //  "Track your Order"
                ].map((item, idx) => (
                  <div key={idx} className="info-link-item" onClick={()=>{navigate(item.link)}}>
                    <ArrowRight className="info-link-arrow" strokeWidth={3} />
                    <span className="info-link-text" >{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="form-wrapper">
            <div className="form-card">
              <h2 className="form-title">Send a Message</h2>
              <p className="form-subtitle">We respond within 2 hours!</p>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon-wrapper">
                    <div className="success-icon-card">
                      <CheckCircle className="success-icon" strokeWidth={3} />
                    </div>
                  </div>
                  <h3 className="success-title">Successfully Sent! 🎉</h3>
                  <p className="success-text">
                    Your message is on its way. We'll respond soon.
                  </p>
                </div>
              ) : (
                <div className="contact-form">
                  <div className="form-row">
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input input-yellow"
                      placeholder="Your Name"
                    />
                    
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input input-purple"
                      placeholder="Email Address"
                    />
                  </div>

                  <input
                    type="text"
                    name="subject"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input input-cyan"
                    placeholder="Subject"
                  />

                  <textarea
                    name="message"
                    required
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea input-pink"
                    placeholder="How we can help you?"
                  />

                  <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="submit-button"
                  >
                    <div className="submit-button-content">
                      {isSubmitting ? (
                        <>
                          <Loader className="submit-icon spinning" strokeWidth={3} />
                          <span>SENDING...</span>
                        </>
                      ) : (
                        <>
                          <span>SEND MESSAGE</span>
                          <ArrowRight className="submit-icon" strokeWidth={3} />
                        </>
                      )}
                    </div>
                  </button>
                </div>
              )}
            </div>
            </div>
          </div>
        </div>
        <div className="social-footer">
          <div className="social-links">
            {[
              { icon: FaWhatsapp, text: 'Whatsapp', colorClass: 'social-whatsapp', shortText: 'Whatsapp', link:'https://whatsapp.com/channel/0029VaWAKYy3bbV18DRRqD2i' },
              { icon: Youtube, text: 'YouTube', colorClass: 'social-youtube', shortText: 'YouTube', link:'https://youtube.com/@flooron4745?si=yZX4hYflaOyVoZkT' },
              { icon: Instagram, text: 'Instagram', colorClass: 'social-instagram', shortText: 'Instagram', link:'https://www.instagram.com/flooron.in?igsh=MXJobWl0anY4czMwZA==' },
              { icon: Facebook, text: 'Facebook', colorClass: 'social-facebook', shortText: 'Facebook', link:'https://www.facebook.com/profile.php?id=61555333351006&mibextid=ZbWKwL' }
            ].map((social, idx) => {
              const Icon = social.icon;
              return (
                <div
                  key={idx}
                  className={`social-link ${social.colorClass}`}
                  onMouseEnter={() => setHoveredSocial(idx)}
                  onMouseLeave={() => setHoveredSocial(null)}
                  style={{ opacity: hoveredSocial === idx || hoveredSocial === null ? 1 : 0.4 }}
                  onClick={() => window.open(social.link, '_blank')} 
                >
                  <Icon className="social-icon" strokeWidth={3} />
                  <span className="social-text-full">{social.text}</span>
                  <span className="social-text-short">{social.shortText}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <p style={{ textAlign: 'center', padding: '20px',color: '#ffffff' }}>
        &copy; {new Date().getFullYear()} Flooron. All rights reserved.
      </p>
    </div>
  );
}